import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Col, FormGroup, FormControl, FormLabel, Row, Collapse} from 'react-bootstrap';
import Axios, { AxiosResponse, CancelTokenSource } from 'axios';
import { APIHelper } from '../../../../../shared/helpers';
import {
    CollectionType,
    CommonListItemType,
} from '../../../../../shared/types/general';
import ModalSelect from '../../../pages/Statistics/ModalSelect';
import { getFilterOptions } from '../../../../../shared/services/AdvancedSearchService';
import { useAppContext } from '../../../../../shared/contexts/AppContextProvider';
import AppYearRange from '../../../../../shared/components/AppYearRange';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSearchContext } from '../../../../../shared/contexts/SearchContextProvider';
import { usePrefiterParams } from '../../../../../shared/hooks';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
interface AdvancedSearchFiltersProps {
    input: any,
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    // eslint-disable-next-line react/require-default-props
    onClosed?: () => any
    // eslint-disable-next-line react/require-default-props
    loading?: boolean
    onChange: (data: any) => void;
    opcoesResultadoRx: any
}

interface AdvancedSearchFiltersType {
    libraries: CommonListItemType[]
    typeOfWorkList: CommonListItemType[]
    collectionList: CommonListItemType[]
    publicationPlaceList: CommonListItemType[]
    languageList: CommonListItemType[]
    internLocation: CollectionType[],
    physicalDescList: CommonListItemType[],
    orderList: CommonListItemType[],
}

const AdvancedSearchFilters:
    React.FC<AdvancedSearchFiltersProps> = ({input,  isOpen, setIsOpen, onChange , opcoesResultadoRx}) => {
    const { t } = useTranslation();

    const [filterOptions, setFilterOptions] = useState<AdvancedSearchFiltersType|undefined>()
    const [selectedLibraries, setSelectedLibraries] = useState<any>([]);
    const [selectedTypeOfWork, setSelectedTypeOfWork] = useState<any>([]);
    const [selectedCollection, setSelectedCollection] = useState<any>([]);
    const [selectedPublicationPlace, setSelectedPublicationPlace] = useState<any>();
    const [selectedLanguage, setSelectedLanguage] = useState<any>();
    const [selectedInternLocation, setSelectedInternLocation] = useState<any>();
    const [selectedPhysicalDesc, setSelectedPhysicalDesc] =  useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [order, setOrder] = useState<string|number|undefined>(undefined)
    const [itemsPerPage, setItemsPerPage] = useState<number|string|undefined>(undefined);
    const [publicationYear, setPublicationYear] = useState<string|undefined>(undefined);
    const [compPublicationYear, setCompPublicationYear] = useState<string|undefined>(undefined);
    const [virtualLib, setVirtualLib] = useState<string>('N');
    const [finalPublicationYear, setFinalPublicationYear] = useState<string|undefined>(undefined);
    const { lang } = useAppContext()
    const { clearSearch} = useSearchContext();
    const { getAll } = usePrefiterParams();
    const { id, id_biblioteca, id_colecao, tipo_obra, cr } = getAll();

    useEffect(() => {
        if(compPublicationYear !== 'entre' && finalPublicationYear){
            setFinalPublicationYear(undefined)
        }
    }, [compPublicationYear]);
    const setInputs = (input: any) => {
        const {
            libraries = undefined,
            typeOfWork= undefined,
            collection= undefined,
            publicationPlace= undefined,
            language= undefined,
            internLocation= undefined,
            physicalDesc= undefined,
            order= undefined,
            itemsPerPage= undefined,
            publicationYear= undefined,
            compPublicationYear= undefined,
            virtualLib= undefined,
            finalPublicationYear = undefined
        } = input;


            setSelectedLibraries(libraries)
            setSelectedTypeOfWork(typeOfWork)
            setSelectedCollection(collection)
            setSelectedPublicationPlace(publicationPlace)
            setSelectedLanguage(language)
            setSelectedInternLocation(internLocation)
            setSelectedPhysicalDesc(physicalDesc)
            setOrder(order)
            setItemsPerPage(itemsPerPage)
            setPublicationYear(publicationYear)
            setCompPublicationYear(compPublicationYear)
            setVirtualLib(virtualLib)
            setFinalPublicationYear(finalPublicationYear)
    }

    useEffect(() => {
        if(input){
            setInputs(input)
        }
    }, [input]);

    useEffect(() => {
        if(onChange && typeof onChange === 'function'){
            onChange({
                libraries: selectedLibraries?.length === filterOptions?.libraries.length ? undefined : selectedLibraries,
                typeOfWork: selectedTypeOfWork?.length === filterOptions?.typeOfWorkList.length ? undefined : selectedTypeOfWork,
                collection: selectedCollection?.length === filterOptions?.collectionList.length ? undefined : selectedCollection,
                publicationPlace: selectedPublicationPlace,
                language: selectedLanguage,
                internLocation: selectedInternLocation,
                physicalDesc: selectedPhysicalDesc,
                order,
                itemsPerPage,
                publicationYear,
                compPublicationYear,
                virtualLib,
                finalPublicationYear
            });
        }
    }, [selectedLibraries, selectedTypeOfWork, selectedCollection, selectedPublicationPlace, selectedLanguage, selectedInternLocation, selectedPhysicalDesc, order, itemsPerPage, publicationYear, compPublicationYear, virtualLib, finalPublicationYear]);
    useEffect(() => {
        const cancelTokenSrc: CancelTokenSource = Axios.CancelToken.source();
        const { token } = cancelTokenSrc;
        setLoading(true);
        getFilterOptions(
            id,
            id_biblioteca,
            id_colecao,
            tipo_obra,
            token
        ).then((response: AxiosResponse<AdvancedSearchFiltersType>) => {
            if(response){
                const { data } = response;
                setFilterOptions(data)
            }
        }).catch((error) => {
            if(!Axios.isCancel(error)){
                APIHelper.tratarErro(error);
                // console.log(error)
            }
        }).finally(() => setLoading(false));
        return () => {
            cancelTokenSrc.cancel();
        }
    }, [lang])


    const handleChangeNumericValue = (setValue: (value: any) => void, value: any) => {
        const newValue = value.replace(/\D/g, '');
        setValue(newValue);
    };

    return (<Collapse in={isOpen}>
        <div>
            <Row className='d-flex align-items-center'>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('Biblioteca')}</FormLabel>
                        {
                            filterOptions !== undefined && filterOptions?.libraries?.length > 0 ? (
                                <ModalSelect
                                    style={{ width: '100%' }}
                                    fem
                                    label={t('EstatisticaSelecionarBiblioteca')}
                                    title={t('EstatisticaSelecionarBiblioteca')}
                                    dataSource={filterOptions.libraries}
                                    // @ts-ignore
                                    renderLabel={x =>
                                        `${x.cod} - ${x.description || t('Desconhecido')}`
                                    }
                                    selectedItems={selectedLibraries}
                                    setSelectedItems={setSelectedLibraries}
                                    keyValue="cod"
                                    keyName="description"
                                    btnCleanSelection
                                    todosI18nIndice={{
                                        fem:'filtrosPesquisaAvancadaTodos',
                                    }}
                                />
                            ) : ''
                        }
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('TipoObra')}</FormLabel>
                        {
                            filterOptions !== undefined && filterOptions?.typeOfWorkList?.length > 0 ? (
                                <ModalSelect
                                    style={{ width: '100%' }}
                                    fem
                                    label={t('TipoObra')}
                                    title={t('TipoObra')}
                                    dataSource={filterOptions.typeOfWorkList}
                                    // @ts-ignore
                                    renderLabel={x =>
                                        `${x.cod} - ${x.description || t('Desconhecido')}`
                                    }
                                    selectedItems={selectedTypeOfWork}
                                    setSelectedItems={setSelectedTypeOfWork}
                                    keyValue="cod"
                                    keyName="description"
                                    btnCleanSelection
                                    todosI18nIndice={{
                                        fem:'filtrosPesquisaAvancadaTodos',
                                    }}
                                />
                            ) : ''
                        }
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('Colecao')}</FormLabel>
                        {
                            filterOptions !== undefined && filterOptions?.collectionList?.length > 0 ? (
                                <ModalSelect
                                    style={{ width: '100%' }}
                                    fem
                                    label={t('Colecao')}
                                    title={t('Colecao')}
                                    dataSource={filterOptions.collectionList}
                                    // @ts-ignore
                                    renderLabel={x =>
                                        `${x.cod} - ${x.description || t('Desconhecido')}`
                                    }
                                    selectedItems={selectedCollection}
                                    setSelectedItems={setSelectedCollection}
                                    keyValue="cod"
                                    keyName="description"
                                    btnCleanSelection
                                    todosI18nIndice={{
                                        fem:'filtrosPesquisaAvancadaTodos',
                                    }}
                                />
                            ) : ''
                        }
                    </FormGroup>
                </Col>
            </Row>
            <Row className='d-flex align-items-center'>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('AnoPublicacao')}</FormLabel>
                        <AppYearRange
                            onChange={({start, end, option}) => {
                                setPublicationYear(start as string|undefined)
                                setFinalPublicationYear(end as string|undefined)
                                setCompPublicationYear(option as string|undefined)
                            }}
                            value={{ start: publicationYear, end: finalPublicationYear?.toString(), option: compPublicationYear || '=' }}
                            options={[
                                {key: '=', value: t('Igual')},
                                {key: '<', value: t('Menor')},
                                {key: '>', value: t('Maior')},
                                {key: 'entre', value: t('Entre')}
                            ]}
                            condSecondInput={({key, value}) => key === 'entre'}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('LugarDePublicacao')}</FormLabel>
                        {
                            filterOptions !== undefined && filterOptions?.publicationPlaceList?.length > 0 ? (
                                <ModalSelect
                                    style={{ width: '100%' }}
                                    label={t('LugarDePublicacao')}
                                    title={t('LugarDePublicacao')}
                                    dataSource={filterOptions.publicationPlaceList}
                                    // @ts-ignore
                                    renderLabel={x =>
                                        `${x.cod} - ${x.description || t('Desconhecido')}`
                                    }
                                    selected={selectedPublicationPlace}
                                    setSelected={setSelectedPublicationPlace}
                                    keyValue="cod"
                                    keyName="description"
                                    multiple={false}
                                    btnCleanSelection
                                    todosI18nIndice={{
                                        fem:'filtrosPesquisaAvancadaTodos',
                                    }}
                                />
                            ) : ''
                        }
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('Idioma')}</FormLabel>
                        {
                            filterOptions !== undefined && filterOptions?.languageList?.length > 0 ? (
                                <ModalSelect
                                    style={{ width: '100%' }}
                                    label={t('Idioma')}
                                    title={t('Idioma')}
                                    dataSource={filterOptions.languageList}
                                    // @ts-ignore
                                    renderLabel={x =>
                                        `${x.cod} - ${x.description || t('Desconhecido')}`
                                    }
                                    selected={selectedLanguage}
                                    setSelected={setSelectedLanguage}
                                    keyValue="cod"
                                    keyName="description"
                                    multiple={false}
                                    btnCleanSelection
                                    todosI18nIndice={{
                                        fem:'filtrosPesquisaAvancadaTodos',
                                    }}
                                />
                            ) : ''
                        }
                    </FormGroup>
                </Col>
            </Row>
            <Row className='d-flex align-items-center'>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('LocalizacaoInterna')}</FormLabel>
                        {
                            filterOptions !== undefined && filterOptions?.internLocation?.length > 0 ? (
                                <ModalSelect
                                    style={{ width: '100%' }}
                                    label={t('LocalizacaoInterna')}
                                    title={t('LocalizacaoInterna')}
                                    dataSource={filterOptions.internLocation}
                                    // @ts-ignore
                                    renderLabel={x =>
                                        `${x.cod} - ${x.description || t('Desconhecido')}`
                                    }
                                    selected={selectedInternLocation}
                                    setSelected={setSelectedInternLocation}
                                    keyValue="cod"
                                    keyName="description"
                                    multiple={false}
                                    btnCleanSelection
                                    todosI18nIndice={{
                                        fem:'filtrosPesquisaAvancadaTodos',
                                    }}
                                />
                            ) : ''
                        }
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('BibliotecaVirtual')}</FormLabel>
                        <FormControl
                            value={cr || virtualLib}
                            disabled={cr !== null}
                            onChange={(e) => setVirtualLib(e.target.value)}
                            as="select">
                            <option value="S">{t('Sim')}</option>
                            <option value="N">{t('Nao')}</option>
                        </FormControl>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <FormLabel>{t('DescricaoFisica')}</FormLabel>
                        {
                            filterOptions !== undefined && filterOptions?.physicalDescList?.length > 0 ? (
                                <ModalSelect
                                    style={{ width: '100%' }}
                                    fem
                                    label={t('DescricaoFisica')}
                                    title={t('DescricaoFisica')}
                                    dataSource={filterOptions.physicalDescList}
                                    // @ts-ignore
                                    renderLabel={x =>
                                        `${x.cod} - ${x.description || t('Desconhecido')}`
                                    }
                                    selected={selectedPhysicalDesc}
                                    setSelected={setSelectedPhysicalDesc}
                                    keyValue="cod"
                                    keyName="description"
                                    multiple={false}
                                    btnCleanSelection
                                    todosI18nIndice={{
                                        fem:'filtrosPesquisaAvancadaTodos',
                                    }}
                                />
                            ) : ''
                        }
                    </FormGroup>
                </Col>
            </Row>
            <Row className='d-flex align-items-center justify-content-center p-2'>
                <button
                    type="button"
                    className="btn-generic--segundo ml-0 "
                    onClick={e => clearSearch()}
                >
                    <FontAwesomeIcon
                        icon={faTrash as IconProp}
                        className="mr-2" />{' '}
                    {t('LimparFiltros')}
                </button>
            </Row>
        </div>
    </Collapse>)
}



const mapStateToProps = (state: any) => ({
    opcoesResultadoRx: state.pesquisa.opcoesResultado,
});

export default connect(mapStateToProps)(AdvancedSearchFilters);
